import { FC } from 'react';
import clsx from 'clsx';
import { Button, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import { ICustomPageSection } from '../../models';

interface IButtonLink {
  section: ICustomPageSection;
  buttonLinkTitleClassName?: string;
  buttonLinkClassName?: string;
}

export const ButtonLink: FC<IButtonLink> = ({ section, buttonLinkTitleClassName, buttonLinkClassName }) => {
  const classes = useStyles();
  return (
    <div className={classes.linkContainer}>
      {section.name && (
        <Typography className={clsx(classes.linkTitle, buttonLinkTitleClassName)} variant="h6">
          {section.name}
        </Typography>
      )}
      <Button fullWidth className={clsx(classes.linkButton, buttonLinkClassName)} href={section.linkUrl} target={'_blank'} variant="contained">
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          {section.linkText ? section.linkText : 'View Information'}
        </Typography>
      </Button>
    </div>
  );
};

const useStyles = makeStyles<Theme>(theme => ({
  linkContainer: {
    textAlign: 'center'
  },
  linkTitle: {
    fontWeight: 'bold',
    marginBottom: theme.spacing(0.5)
  },
  linkButton: {
    fontWeight: 'bold',
    fontSize: '16px',
    padding: theme.spacing(0.75, 1.25)
  }
}));
